module.exports = __webpack_public_path__ + "static/img/avatar_advi@3x.7ca1f0b0.png";